module.exports = __webpack_public_path__ + "static/media/3.89e0f074.jpg";